export default __webpack_public_path__ + "static/media/fluster_lobby_background_small.014865c0.png";